import { AuthenticationMethodsPolicy } from '@microsoft/microsoft-graph-types-beta';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { Status, initialStatus } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'authenticationMethodsPolicies';

export interface State extends Status {
    policy?: AuthenticationMethodsPolicy;
}

export const initialState: State = {
    updating: false,
    error: null,
    loaded: false,
    policy: undefined,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,
    on(actions.loadAuthenticationMethodsPoliciesSuccess, (state, { policy }) => ({
        ...state,
        policy,
        error: false,
        loaded: true,
    })),
    on(actions.loadAuthenticationMethodsPoliciesFailure, (state, { error }) => ({
        ...state,
        error,
        loaded: false,
    })),
    on(actions.updateAuthenticationMethodPolicyConfig, (state) => ({
        ...state,
        updating: true,
    })),
    on(actions.updateAuthenticationMethodPolicyConfigSuccess, (state, { policy }) => {
        if (!state.policy || !state.policy.authenticationMethodConfigurations) return state;

        // check this
        const updatedConfigs = state.policy.authenticationMethodConfigurations.map((c: any) =>
            c.id === policy.id ? { ...c, ...policy } : c,
        );
        return {
            ...state,
            policy: {
                ...state.policy,
                authenticationMethodConfigurations: updatedConfigs,
            },
            updating: false,
            error: false,
        };
    }),
    on(actions.updateAuthenticationMethodPolicyConfigFailure, (state, { error }) => ({
        ...state,
        updating: false,
        error,
    })),
);

export const selectPolicy = (state: State) => state.policy;
export const selectError = (state: State) => state.error;
